<template>
    <div>
        <el-card shadow="never">
            <el-form class="app-form" ref="formRef" :model="form" size="medium" label-width="130px">
                <el-form-item
                :label="$t('select_project_space')"
                prop="space_id"
                :rules="[
                    { required: true, message: $t('project_space_cannot_empty'), trigger: 'blur'},
                ]">
                    <el-select
                    @change="changeSpaceHandler"
                    v-model="form.space_id" 
                    filterable 
                    :placeholder="$t('please_input_keyword')">
                        <el-option
                        v-for="space in spaceList"
                        :key="space.id"
                        :label="space.name"
                        :value="space.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item 
                :label="$t('select_template')"
                prop="template_id"
                :rules="[
                    { required: true, message: $t('template_cannot_empty'), trigger: 'blur'},
                ]">
                    <el-select 
                    v-model="form.template_id" 
                    filterable 
                    :placeholder="$t('please_input_keyword')">
                        <el-option
                        v-for="proj in templateList"
                        :key="proj.id"
                        :label="proj.name"
                        :value="proj.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button  icon="el-icon-edit-outline" size="small" type="primary" @click="openDialogHandler">{{ $t('input_apply_order') }}</el-button>
                </el-form-item>

            </el-form>
        </el-card>


        <el-dialog
        :width="$root.DialogNormalWidth"
        :title="$t('input_deploy_apply')"
        :visible.sync="dialogVisible"
        @close="closeDialogHandler">
            <div class="app-dialog" v-loading="dialogLoading">
                <el-form class="app-form" ref="dialogRef" :model="dialogForm" size="medium" label-width="130px">
                    <el-form-item 
                    :label="$t('command_template_name')">
                        {{ templateDetail.name }}
                    </el-form-item>
               
                    <el-form-item 
                    :label="$t('command_name')"
                    prop="name"
                    :rules="[
                        { required: true, message: $t('name_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :placeholder="$t('please_input_name')" v-model="dialogForm.name" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('command_mode')">
                        <span v-if="form.tmode == 1">
                            <i class="iconfont icon-branch"></i> - {{ $t('tpl_mode') }}<template v-if="form.tmode==2"> - <strong>{{ templateDetail.id }}</strong> {{ $t('flow_mode') }}</template>
                        </span>
                        <span v-if="form.tmode == 2">
                            <i class="iconfont icon-tag"></i> {{ $t('tag_deploy') }}
                        </span>
                    </el-form-item>

                 
                    <el-form-item 
                    :label="$t('command_illustrate')"
                    prop="description"
                    :rules="[
                        { required: true, message: $t('command_illustrate_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :rows="4" type="textarea" :placeholder="$t('please_input_command_illustrate')" v-model="dialogForm.description" autocomplete="off"></el-input>
                    </el-form-item>

                    
                 </el-form>
                 <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeDialogHandler">{{ $t('cancel') }}</el-button>
                    <el-button :loading="btnLoading" size="small" type="primary" @click="dialogSubmitHandler">{{ $t('enter') }}</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    detailSpaceApi,
    listSpaceApi,
} from '@/api/project.js'

import { TemplateDetailApi, TemplateListApi, OperateSubmitApi } from '@/api/command.js'
import { applySubmitApi } from '@/api/deploy'
export default {
    data() {
        return {
            form: {
                space_id: undefined,
                template_id: undefined,
                tmode: 1,
            },
            spaceList: [],
            templateList: [],
            rollbackList: [],

            dialogVisible: false,
            dialogLoading: false,
            dialogForm: {
                id: 0,
                flow_id: 0,
            },
            btnLoading: false,
            templateDetail: {},
            flowDetail: {},
        }
    },
    methods: {
        dialogSubmitHandler() {
            this.$refs.dialogRef.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.btnLoading = true
                let postData = {
                    id: this.dialogForm.id,
                    flow_id: this.dialogForm.flow_id,
                    template_id: this.form.template_id,
                    space_id: this.form.space_id,
                    tmode: this.form.tmode,
                    name: this.dialogForm.name,
                    description: this.dialogForm.description,
                }
                OperateSubmitApi(postData).then(res => {
                    this.$alert(this.$t('command_apply_submit_success'), this.$t('submit_success'), {
                        type: 'success',
                        confirmButtonText: this.$t('enter'),
                        callback: action => {
                            this.closeDialogHandler()
                            this.$router.push({name: 'commandOperate'})
                        }
                    })
                    this.btnLoading = false
                }).catch(err => {
                    this.btnLoading = false
                })
            })
        },
        openDialogHandler() {
            this.$refs.formRef.validate((valid) => {
                if (!valid) {
                    return false;
                }
                TemplateDetailApi({id: this.form.template_id}).then(res => {
                    this.templateDetail = res
                    this.dialogVisible = true
                })
                
            })
        },
        closeDialogHandler() {
            this.dialogVisible = false
        },
        changeSpaceHandler(spaceId) {
            this.form.template_id = undefined
            this.loadTemplateList(spaceId)
        },
        loadSpaceList() {
            listSpaceApi({offset: 0, limit : 999}).then(res => {
                if (res.list) {
                    this.spaceList = res.list
                }
            })
        },
        loadTemplateList(spaceId) {
            TemplateListApi({space_id: spaceId, offset: 0, limit : 999}).then(res => {
                if (res.list) {
                    this.templateList = res.list
                }
            })
        },
    },
    mounted() {
        this.loadSpaceList()
    },
}
</script>
